'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _components = require('../../components');

var _FamilyFactSheet = require('./FamilyFactSheet.css');

var _FamilyFactSheet2 = _interopRequireDefault(_FamilyFactSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyFactSheet = (_dec = (0, _reactCssModules2.default)(_FamilyFactSheet2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FamilyFactSheet, _Component);

  function FamilyFactSheet(props) {
    (0, _classCallCheck3.default)(this, FamilyFactSheet);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FamilyFactSheet.__proto__ || (0, _getPrototypeOf2.default)(FamilyFactSheet)).call(this, props));

    _this.renderVanguard = function (stats) {
      return _react2.default.createElement(
        'div',
        { styleName: 'fs-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'fs-title' },
          'How Vanguard is invested in the climate crisis'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Vanguard is the second largest asset manager in the world with over $5.6 trillion of assets under management. It is the largest provider of mutual funds and second largest provider of exchange-traded funds (ETF) in the U.S. Vanguard has billions of dollars invested in fossil fuels and agribusinesses responsible for deforestation - the two greatest contributors to the climate crisis.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'Vanguard\'s climate risk by the numbers'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness - the two greatest contributors to the climate crisis.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.df_producer_asset_sum
            ),
            ' invested in deforestation-risk agribusiness companies (palm oil, paper/pulp, rubber, timber, cattle, and soy).'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.ff_all_asset_sum
            ),
            ' invested in fossil fuel companies in Vanguard funds. ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://fossilfreefunds.org/families?q=Vanguard', title: 'Vanguard | Fossil Free Funds', xstrong: true },
              '(See more on Vanguard\'s fossil fuel investments at Fossil Free Funds.)'
            )
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness in Vanguard\'s so-called "sustainable" funds.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-disclaimer' },
          _react2.default.createElement(
            'em',
            null,
            'As of ',
            stats.as_of,
            '. Portfolios analyzed include U.S.-domiciled open-end funds and exchange-traded funds (ETFs) with at least 40% of assets invested directly in equities. Figures do not include any exposure from other asset classes such as fixed income funds, collective trusts, or funds domiciled outside the U.S. Some companies tracked are active in both fossil fuels and agribusiness, and this is reflected in the totals.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Vanguard\'s investments in deforestation and climate crisis include exposure to companies that are driving unprecedented fires in the Amazon Rainforest, destruction of critical wildlife habitats in Indonesia, and gross human rights violations around the world.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Bunge, Archer Daniels Midland, and JBS'
            ),
            ' have expansive plantations in Brazil that helped create the conditions for fires in the Amazon Rainforest resulting in the destruction of hundreds of thousands of hectares of forest. JBS in particular has also been implicated in illegal practices and corruption.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Wilmar International'
            ),
            ' is the largest palm oil trader in the world and holds a land bank of over 1,500,000 acres in Malaysia, Indonesia, West Africa and the Congo basin. Wilmar\'s operations have been frequently linked with deforestation, land grabbing, water pollution, protracted conflicts, bribery, destruction of critical wildlife habitat and forest fires. In 2013, Wilmar adopted a No Deforestation, No Peatland Destruction, No Exploitation policy; however ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://www.greenpeace.org/international/press-release/18485/greenpeace-investigation-wilmar-brands-palm-oil-deforestation-indonesia/', title: 'Wilmar Brands - Greenpeace', xstrong: true },
              'independent reports'
            ),
            ' have found that since 2013, Wilmar\'s suppliers have cleared a forest area totaling 21,500 hectares.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Posco'
            ),
            ' and its subsidiary PT Bio Inti Agrindo (PT BIA) are responsible for destroying 26,500 hectares of forest in Indonesia\'s Papua province. In 2015, the Norwegian Sovereign Wealth Fund divested from Posco Daewoo/Posco International and in June 2018 ABP, the world fifth largest pension fund, divested 300,000 Euros from the company over its failure to address deforestation.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What is in Vanguard\'s supposed "sustainable" funds?'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Vanguard currently offers four funds that have a sustainability mandate. However, three out of four of Vanguard\'s "sustainable" funds include investments in both fossil fuels and deforestation-risk agribusiness companies.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'The dirtiest "sustainable" fund contains ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_with_most_climate_asset
            ),
            ' in fossil fuel and deforestation-risk agribusiness companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'In total, Vanguard\'s "sustainable funds" contain ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' in the companies driving the climate crisis.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'A lack of relevant or robust climate policies'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Vanguard lacks relevant or robust policies regarding climate change, deforestation, or land grabbing. In the Vanguard\'s \'responsible investing policy overview,\' the company mentions proxy voting, "effective management of environmental and social risks as an integrated component of good corporate governance practices," and "acting on environmental, social, and governance risks opportunities or risks." Vanguard does not have explicit policies to guide their investments or engagement with companies responsible for deforestation, land grabbing, or increased greenhouse gas emissions. Notably, within its ESG investing, Vanguard states that it takes into account "human rights, labor, and environmental concerns" in certain "sustainable funds," however a look under the hood reveals that even those funds include companies found to engaged in deforestation, land grabbing, and rights violations.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What should Vanguard Do?'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Make sustainability the default:'
            ),
            ' Make fossil fuel and deforestation-free funds the default for all its investment products.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Disclose'
            ),
            ' its exposure to climate, deforestation, and related human rights risks.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Commit'
            ),
            ' to robust climate and no deforestation policies in order to reduce exposure to ESG risk and drive change in investee companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Exclude'
            ),
            ' from investment portfolios companies that routinely engage in deforestation, human rights abuses, and massive carbon emissions.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Repair'
            ),
            ' the damage by engaging with companies to remedy past harms through restoring damaged forests and eco-systems and implementing active and responsive grievance mechanisms.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-cta' },
          'Help Vanguard clean up its act on deforestation and climate risk. ',
          _react2.default.createElement(
            _components.Link,
            {
              to: 'https://actionnetwork.org/petitions/vanguard-needs-a-no-deforestation-policy-2',
              title: 'Vanguard Needs a No Deforestation Policy',
              xstrong: true
            },
            'Sign the petition',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        )
      );
    };

    _this.renderStateStreet = function (stats) {
      return _react2.default.createElement(
        'div',
        { styleName: 'fs-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'fs-title' },
          'How State Street is invested in the climate crisis'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'State Street Global Advisors is the fourth largest asset manager in the world (and third largest in the United States) with over $2.8 trillion of assets under management. The Boston-based investor has billions of dollars invested in fossil fuels and agribusinesses responsible for deforestation \u2013 the two greatest contributors to the climate crisis.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'State Street\'s climate risk by the numbers'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness - the two greatest contributors to the climate crisis.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.df_producer_asset_sum
            ),
            ' invested in deforestation-risk agribusiness companies (palm oil, paper/pulp, rubber, timber, cattle, and soy).'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.ff_all_asset_sum
            ),
            ' invested in fossil fuel companies in State Street funds. ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://fossilfreefunds.org/families?q=SPDR%20State%20Street%20Global%20Advisors', title: 'State Street Global Advisors | Fossil Free Funds', xstrong: true },
              '(See more on State Street\'s fossil fuel investments at Fossil Free Funds.)'
            )
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness in State Street\'s so-called "sustainable" funds.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-disclaimer' },
          _react2.default.createElement(
            'em',
            null,
            'As of ',
            stats.as_of,
            '. Portfolios analyzed include U.S.-domiciled open-end funds and exchange-traded funds (ETFs) with at least 40% of assets invested directly in equities. Figures do not include any exposure from other asset classes such as fixed income funds, collective trusts, or funds domiciled outside the U.S. Some companies tracked are active in both fossil fuels and agribusiness, and this is reflected in the totals.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'State Street\'s investments in deforestation and climate crisis include exposure to companies that are driving unprecedented fires in the Amazon Rainforest, destruction of critical wildlife habitats in Indonesia, and gross human rights violations around the world.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Bunge, Archer Daniels Midland, and JBS'
            ),
            ' have expansive plantations in Brazil that helped create the conditions for fires in the Amazon Rainforest resulting in the destruction of hundreds of thousands of hectares of forest. JBS in particular has also been implicated in illegal practices and corruption.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Wilmar International'
            ),
            ' is the largest palm oil trader in the world and holds a land bank of over 1,500,000 acres in Malaysia, Indonesia, West Africa and the Congo basin. Wilmar\'s operations have been frequently linked with deforestation, land grabbing, water pollution, protracted conflicts, bribery, destruction of critical wildlife habitat and forest fires. In 2013, Wilmar adopted a No Deforestation, No Peatland Destruction, No Exploitation policy; however ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://www.greenpeace.org/international/press-release/18485/greenpeace-investigation-wilmar-brands-palm-oil-deforestation-indonesia/', title: 'Wilmar Brands - Greenpeace', xstrong: true },
              'independent reports'
            ),
            ' have found that since 2013, Wilmar\'s suppliers have cleared a forest area totaling 21,500 hectares.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Posco'
            ),
            ' and its subsidiary PT Bio Inti Agrindo (PT BIA) are responsible for destroying 26,500 hectares of forest in Indonesia\'s Papua province. In 2015, the Norwegian Sovereign Wealth Fund divested from Posco Daewoo/Posco International and in June 2018 ABP, the world fifth largest pension fund, divested 300,000 Euros from the company over its failure to address deforestation.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What is in Vanguard\'s supposed "sustainable" funds?'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'State Street currently offers six funds that have a sustainability mandate. However, four out of six of State Street\'s "sustainable" funds include investments in both fossil fuels and deforestation-risk agribusiness companies.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'The dirtiest "sustainable" fund contains ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_with_most_climate_asset
            ),
            ' in fossil fuel and deforestation-risk agribusiness companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'In total, State Street\'s "sustainable funds" contain ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' in the companies driving the climate crisis.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'Despite recognizing climate risk, State Street\u2019s policies fall short'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'State Street has no explicit policies on deforestation or land grabbing. While State Street CEO Ronald O\u2019Hanley ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://www.linkedin.com/pulse/climate-change-material-risk-we-all-must-address-ronald-o-hanley/', title: 'Climate Change Is a Material Risk We All Must Address | Ronald O\'Hanley', xstrong: true },
            'says'
          ),
          ' his investment firm recognizes the  material risk posed by climate crisis, he fails to point to tangible actions or policies State Street has adopted to act on these risks. Beyond endorsing carbon-pricing mechanisms and calling for increased disclosure, State Street does not have explicit policies to guide their investments or engagement with companies responsible for deforestation, land grabbing, or increased greenhouse gas emissions. Notably, State Street did not sign on to a ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://www.ceres.org/sites/default/files/Investor statement on deforestation and forest fires in the Amazon.pdf', title: 'Investor statement on deforestation and forest fires in the Amazon | Ceres', xstrong: true },
            '2019 investor statement'
          ),
          ' calling for action regarding Amazon fires.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What should State Street Do?'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Make sustainability the default:'
            ),
            ' Make fossil fuel and deforestation-free funds the default for all its investment products.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Disclose'
            ),
            ' its exposure to climate, deforestation, and related human rights risks.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Commit'
            ),
            ' to robust climate and no deforestation policies in order to reduce exposure to ESG risk and drive change in investee companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Exclude'
            ),
            ' from investment portfolios companies that routinely engage in deforestation, human rights abuses, and massive carbon emissions.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Repair'
            ),
            ' the damage by engaging with companies to remedy past harms through restoring damaged forests and eco-systems and implementing active and responsive grievance mechanisms.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-cta' },
          'Help State Street clean up its act on deforestation and climate risk. ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://actionnetwork.org/petitions/state-street-needs-a-no-deforestation-policy', title: 'State Street Needs a No Deforestation Policy', xstrong: true },
            'Sign the petition',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        )
      );
    };

    _this.renderFidelity = function (stats) {
      return _react2.default.createElement(
        'div',
        { styleName: 'fs-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'fs-title' },
          'How Fidelity is invested in the climate crisis'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Fidelity Investments is the fifth largest asset manager in the world (and fourth largest in the United States) with over $2.7 trillion of assets under management. Fidelity has billions of dollars invested in fossil fuels and agribusinesses responsible for deforestation \u2013 the two greatest contributors to the climate crisis.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'Fidelity\'s climate risk by the numbers'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness - the two greatest contributors to the climate crisis.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.df_producer_asset_sum
            ),
            ' invested in deforestation-risk agribusiness companies (palm oil, paper/pulp, rubber, timber, cattle, and soy).'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.ff_all_asset_sum
            ),
            ' invested in fossil fuel companies in Fidelity funds. ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://fossilfreefunds.org/families?q=Fidelity%20Investments', title: 'Fidelity Investments | Fossil Free Funds', xstrong: true },
              '(See more on Fidelity\'s fossil fuel investments at Fossil Free Funds.)'
            )
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness in Fidelity\'s so-called "sustainable" funds.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-disclaimer' },
          _react2.default.createElement(
            'em',
            null,
            'As of ',
            stats.as_of,
            '. Portfolios analyzed include U.S.-domiciled open-end funds and exchange-traded funds (ETFs) with at least 40% of assets invested directly in equities. Figures do not include any exposure from other asset classes such as fixed income funds, collective trusts, or funds domiciled outside the U.S. Some companies tracked are active in both fossil fuels and agribusiness, and this is reflected in the totals.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Fidelity\'s investments in deforestation and climate crisis include exposure to companies that are driving unprecedented fires in the Amazon Rainforest, destruction of critical wildlife habitats in Indonesia, and gross human rights violations around the world.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Bunge, Archer Daniels Midland, and JBS'
            ),
            ' have expansive plantations in Brazil that helped create the conditions for fires in the Amazon Rainforest resulting in the destruction of hundreds of thousands of hectares of forest. JBS in particular has also been implicated in illegal practices and corruption.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Wilmar International'
            ),
            ' is the largest palm oil trader in the world and holds a land bank of over 1,500,000 acres in Malaysia, Indonesia, West Africa and the Congo basin. Wilmar\'s operations have been frequently linked with deforestation, land grabbing, water pollution, protracted conflicts, bribery, destruction of critical wildlife habitat and forest fires. In 2013, Wilmar adopted a No Deforestation, No Peatland Destruction, No Exploitation policy; however ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://www.greenpeace.org/international/press-release/18485/greenpeace-investigation-wilmar-brands-palm-oil-deforestation-indonesia/', title: 'Wilmar Brands - Greenpeace', xstrong: true },
              'independent reports'
            ),
            ' have found that since 2013, Wilmar\'s suppliers have cleared a forest area totaling 21,500 hectares.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Posco'
            ),
            ' and its subsidiary PT Bio Inti Agrindo (PT BIA) are responsible for destroying 26,500 hectares of forest in Indonesia\'s Papua province. In 2015, the Norwegian Sovereign Wealth Fund divested from Posco Daewoo/Posco International and in June 2018 ABP, the world fifth largest pension fund, divested 300,000 Euros from the company over its failure to address deforestation.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What is in Fidelity\'s supposed "sustainable" funds?'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Fidelity currently offers four funds that have a sustainability mandate. However, two out of four of State Street\'s "sustainable" funds include investments in both fossil fuels and deforestation-risk agribusiness companies.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'The dirtiest "sustainable" fund contains ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_with_most_climate_asset
            ),
            ' in fossil fuel and deforestation-risk agribusiness companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'In total, Fidelity\'s "sustainable funds" contain ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' in the companies driving the climate crisis.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'More needed in terms of policies and practices when it comes to environmental sustainability'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Fidelity has no explicit policies on deforestation or land grabbing. Despite a number of statements and webpages on sustainable investing that mention \u201Cenvironmental impact,\u201D \u201CESG issues,\u201D and \u201Cclimate change and carbon emissions,\u201D the firm lacks policies that indicate how it takes into account climate, increased emissions, and deforestation in its investment approach. While climate change and carbon emissions are specifically mentioned, deforestation and its impacts are noticeably missing from Fidelity\u2019s approach to sustainability and responsible investing.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What should Fidelity Do?'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Make sustainability the default:'
            ),
            ' Make fossil fuel and deforestation-free funds the default for all its investment products.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Disclose'
            ),
            ' its exposure to climate, deforestation, and related human rights risks.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Commit'
            ),
            ' to robust climate and no deforestation policies in order to reduce exposure to ESG risk and drive change in investee companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Exclude'
            ),
            ' from investment portfolios companies that routinely engage in deforestation, human rights abuses, and massive carbon emissions.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Repair'
            ),
            ' the damage by engaging with companies to remedy past harms through restoring damaged forests and eco-systems and implementing active and responsive grievance mechanisms.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-cta' },
          'Help Fidelity clean up its act on deforestation and climate risk. ',
          _react2.default.createElement(
            _components.Link,
            {
              to: 'https://actionnetwork.org/petitions/fidelity-needs-a-no-deforestation-policy-2',
              title: 'Fidelity Needs a No Deforestation Policy',
              xstrong: true
            },
            'Sign the petition',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        )
      );
    };

    _this.renderBlackRockiShares = function (stats) {
      return _react2.default.createElement(
        'div',
        null,
        'Lorem BlackRock / iShares'
      );
    };

    _this.renderTIAANuveen = function (stats) {
      return _react2.default.createElement(
        'div',
        { styleName: 'fs-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'fs-title' },
          'How TIAA/Nuveen is invested in the climate crisis'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'Teachers Insurance and Annuity Association of America (TIAA), with $1 trillion of assets under management, is the leading retirement fund manager for university faculty, and non-profit professionals. TIAA and its subsidiary Nuveen have billions of dollars invested in fossil fuels and the agribusinesses responsible for deforestation \u2013 the two greatest contributors to the climate crisis.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'TIAA/Nuveen\'s climate risk by the numbers'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness - the two greatest contributors to the climate crisis.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.df_producer_asset_sum
            ),
            ' invested in deforestation-risk agribusiness companies (palm oil, paper/pulp, rubber, timber, cattle, and soy).'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.ff_all_asset_sum
            ),
            ' invested in fossil fuel companies in TIAA/Nuveen funds. (See more on ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://fossilfreefunds.org/families?q=TIAA%20Investments%2FNuveen', title: 'TIAA Investments/Nuveen | Fossil Free Funds', xstrong: true },
              'TIAA Investments/Nuveen\'s'
            ),
            ' fossil fuel investments at Fossil Free Funds.)'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' invested in fossil fuels and agribusiness in TIAA/Nuveen\'s so-called "sustainable" funds.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-disclaimer' },
          _react2.default.createElement(
            'em',
            null,
            'As of ',
            stats.as_of,
            '. Portfolios analyzed include U.S.-domiciled open-end funds and exchange-traded funds (ETFs) with at least 40% of assets invested directly in equities. Figures do not include any exposure from other asset classes such as fixed income funds, collective trusts, or funds domiciled outside the U.S. Some companies tracked are active in both fossil fuels and agribusiness, and this is reflected in the totals.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'TIAA/Nuveen\'s investments in deforestation and climate crisis include exposure to companies that are driving unprecedented fires in the Amazon Rainforest, destruction of critical wildlife habitats in Indonesia, and gross human rights violations around the world.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Bunge, Archer Daniels Midland, and JBS'
            ),
            ' have expansive plantations in Brazil that helped create the conditions for fires in the Amazon Rainforest resulting in the destruction of hundreds of thousands of hectares of forest. JBS in particular has also been implicated in illegal practices and corruption.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Indofood'
            ),
            ', Indonesia\u2019s largest food processing company, has illegally cleared 10,00 hectares of forest in Borneo for palm oil plantations. The Roundtable on Sustainable Palm Oil affirmed an Indofood Agri subsidiary in 23 offences including child labor, gender discrimination and toxic working conditions.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Posco'
            ),
            ' and its subsidiary PT Bio Inti Agrindo (PT BIA) are responsible for destroying 26,500 hectares of forest in Indonesia\'s Papua province. In 2015, the Norwegian Sovereign Wealth Fund divested from Posco Daewoo/Posco International and in June 2018 ABP, the world fifth largest pension fund, divested 300,000 Euros from the company over its failure to address deforestation.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What is in TIAA Investments\' "Social Choice" funds?'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'TIAA currently offers three mutual funds, branded as \u201CSocial Choice Funds\u201D because of their sustainability profiles. However, all three of TIAA\u2019s Social Choice funds include fossil fuel and deforestation-risk agribusiness companies. Nuveen offers seven ESG ETFs, four of which include agribusiness investments, and all of which include fossil fuel holdings.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'The dirtiest Social Choice fund contains ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_with_most_climate_asset
            ),
            ' in fossil fuel and deforestation-risk agribusiness companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'In total, TIAA/Nuveen\'s "sustainable" funds contain ',
            _react2.default.createElement(
              'span',
              { styleName: 'fs-stat' },
              stats.sri_climate_asset_sum
            ),
            ' in the companies driving the climate crisis.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'Weak policies enable dirty practices'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'TIAA has no policy in place to manage deforestation risk in its equity portfolios. In August 2018, TIAA subsidiary Nuveen adopted a ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://www.tiaa.org/public/pdf/doc/nuveens_zero_deforestation_policy_in_brazil.pdf', title: 'Nuveen\u2019s Zero Deforestation Policy in Brazil | Nuveen', xstrong: true },
            '\u201CZero-Deforestation Policy in Brazil.\u201D'
          ),
          ' Under the policy, TIAA/Nuveen \u201Cwill not acquire land on behalf of any of its accounts in Brazil that has been cleared from native vegetation\u201D after a set of dates specific to biomes named in the policy. While the policy shows that TIAA is attentive to the concerns of deforestation, its scope does not extend to farmland already held in its portfolio. Independent research has shown that TIAA\u2019s farms in the fragile Brazilian Cerrado have been cleared of ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://chainreactionresearch.com/report/foreign-farmland-investors-in-brazil-linked-to-423000-hectares-of-deforestation/', title: 'Foreign Farmland Investors in Brazil Linked to 423,000 Hectares of Deforestation | Chain Reaction Research', xstrong: true },
            '72,000 hectares'
          ),
          ' of forest since 2000. Further, georeferenced data obtained by independent researchers reveals that TIAA\u2019s Brazilian subsidiary Radar SA ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://chainreactionresearch.com/report/tiaas-farmland-funds-linked-to-fires-conflicts-and-legacy-deforestation-risks-in-brazil/', title: 'TIAA\u2019s Farmland Funds Linked to Fires, Conflicts and Legacy Deforestation Risks in Brazil | Chain Reaction Research', xstrong: true },
            'deforested'
          ),
          ' at least one of its Brazilian properties soon after purchase.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'TIAA\u2019s land holdings in Brazil are implicated in deforestation and human rights violations'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-copy' },
          'TIAA\u2019s land holdings in the Cerrado region of Brazil are driving deforestation, wildfires and land conflicts \u2013 all of which pose significant financial risk to clients. A ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://chainreactionresearch.com/report/tiaas-farmland-funds-linked-to-fires-conflicts-and-legacy-deforestation-risks-in-brazil/', title: 'TIAA\u2019s Farmland Funds Linked to Fires, Conflicts and Legacy Deforestation Risks in Brazil | Chain Reaction Research', xstrong: true },
            '2020 report'
          ),
          ' found that:'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'By establishing a majority-owned subsidiary called Radar in Brazil, TIAA appears to use complex corporate structures to circumvent legal restrictions on foreign land ownership.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'Despite a recent increase in transparency, the land portfolio in TIAA\u2019s investment vehicles remains unclear. TIAA\u2019s asset manager, Nuveen, maintains a public map with farmland holdings. However, Nuveen\u2019s information does not fully match public ownership records.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'Between 2009 and 2018, 2,970 hectares of vegetation were cleared on six TIAA farms in the Cerrado. In August 2019, fires burned 2,350 hectares on three of these farms.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'TIAA subsidiary Radar\u2019s properties have been linked to land-grabbing and conflicts with local communities in the Matopiba region.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            'Value loss in Radar\u2019s portfolio in Matopiba could amount to ',
            _react2.default.createElement(
              _components.Link,
              { to: 'https://chainreactionresearch.com/report/tiaas-farmland-funds-linked-to-fires-conflicts-and-legacy-deforestation-risks-in-brazil/', title: 'TIAA\u2019s Farmland Funds Linked to Fires, Conflicts and Legacy Deforestation Risks in Brazil | Chain Reaction Research', xstrong: true },
              'USD $192 million.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-subtitle' },
          'What should TIAA/Nuveen Do?'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'fs-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Make sustainability the default:'
            ),
            ' Make fossil fuel and deforestation-free funds the default for all its investment products.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Disclose'
            ),
            ' its exposure to climate, deforestation, and related human rights risks.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Commit'
            ),
            ' to robust climate and no deforestation policies in order to reduce exposure to ESG risk and drive change in investee companies.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Exclude'
            ),
            ' from investment portfolios companies that routinely engage in deforestation, human rights abuses, and massive carbon emissions.'
          ),
          _react2.default.createElement(
            'li',
            { styleName: 'fs-li' },
            _react2.default.createElement(
              'strong',
              null,
              'Repair'
            ),
            ' the damage by engaging with companies to remedy past harms through restoring damaged forests and eco-systems and implementing active and responsive grievance mechanisms.'
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fs-cta' },
          'Help TIAA/Nuveen clean up its act on deforestation and climate risk. ',
          _react2.default.createElement(
            _components.Link,
            { to: 'https://actionnetwork.org/petitions/tiaanuveen-needs-a-deforestation-and-land-grab-free-investment-policy', title: 'TIAA/Nuveen Needs a No Deforestation Policy', xstrong: true },
            'Sign the petition',
            _react2.default.createElement(_components.LinkIcon, null)
          )
        )
      );
    };

    return _this;
  }

  (0, _createClass3.default)(FamilyFactSheet, [{
    key: 'render',
    value: function render() {
      var money = function money(x) {
        return _format2.default.money(x, true, 'US Dollar', false, 0);
      };
      var fam = this.props.fam;

      var stats = {};
      stats.climate_asset_sum = money(fam.climate_asset_sum);
      stats.df_producer_asset_sum = money(fam.df_producer_asset_sum);
      stats.ff_all_asset_sum = money(fam.ff_all_asset_sum);
      stats.sri_climate_asset_sum = money(fam.sri_climate_asset_sum);
      stats.sri_with_most_climate_asset = money(fam.sri_with_most_climate_asset);
      stats.as_of = (0, _moment2.default)(fam.as_of, 'YYYYMM').format('MMMM YYYY');

      if (fam.fund_family_label === 'Vanguard') {
        return this.renderVanguard(stats);
      } else if (fam.fund_family_label === 'Fidelity Investments') {
        return this.renderFidelity(stats);
      } else if (fam.fund_family_label === 'SPDR State Street Global Advisors') {
        return this.renderStateStreet(stats);
      } else if (fam.fund_family_label === 'TIAA Investments/Nuveen') {
        return this.renderTIAANuveen(stats);
      } else {
        return null;
      }
      // When we finish drafting BlackRock/iShares content
      // else if (fam.fund_family_label === 'BlackRock/iShares') {
      //   return this.renderBlackRockiShares(stats)
      // } 
    }
  }]);
  return FamilyFactSheet;
}(_react.Component), _class2.propTypes = {
  fam: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = FamilyFactSheet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FamilyFactSheet/FamilyFactSheet.js
// module id = 1319
// module chunks = 0